import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const create_login_token = createAsyncThunk(
  "Authentication/create_login_token",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/admin/send-jsw-token`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("category Not create");
    }
  }
);
export const get_protected_data = createAsyncThunk(
  "Authentication/get_protected_data",
  async (token, thunkAPI) => {
    try {
      const config = {
        headers: {
          authorization: `${token}`,
        },
      };
      const url = `${Baseurl}/api/v1/admin/get-protected-admin-data`;
      const resp = await axios.post(url, null, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("admin Not get");
    }
  }
);

export const send_otp = createAsyncThunk(
  "Authentication/send_otp",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/admin/send-otp`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("category Not create");
    }
  }
);



const initialState = {
  isfdAdminAuth: JSON.parse(localStorage.getItem("isfdAdminAuth"))
    ? JSON.parse(localStorage.getItem("isfdAdminAuth"))
    : "",
};

const AuthenticationSlice = createSlice({
  name: "Authentication",
  initialState,
  reducers: {
    admin_auth(state, action) {
      state.isfdAdminAuth = action.payload;
      localStorage.setItem(
        "isfdAdminAuth",
        JSON.stringify(state.isfdAdminAuth)
      );
    },
  },
});

export const { admin_auth } = AuthenticationSlice.actions;
export const authActions = AuthenticationSlice.actions;
export default AuthenticationSlice.reducer;
